'use strict';

angular.module('amexReconciliationApp')
    .service('NotificationsRepository',
        function NotificationsRepository($resource) {
            var notifications = [];
            var notificationsShown = false;
            var self = this;
            var notificationsResource = $resource('/api/v1/notifications');
            var notificationsBroadcastResource = $resource('/api/v1/notifications/broadcast');
            var notificationsSystemBroadcastResource = $resource('/api/v1/notifications/system-broadcast-messages');

            self.getNotifications = function () {
                return notificationsResource.query().$promise;
            };

            self.getNotificationsBroadcast = function () {
                return notificationsBroadcastResource.query().$promise;
            };

            self.getNotificationsSystemBroadcast = function () {
                return notificationsSystemBroadcastResource.query().$promise;
            };
        });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/NotificationsRepository.js
// module id = 614
// module chunks = 0